import {
  Alert,
  Collapse,
  Descriptions,
  Table,
  Tag,
  Typography,
} from 'antd';
import { useTranslation } from 'react-i18next';

const statusKeys = [
  'IMPORTED',
  'AI_PASSED',
  'AI_WARNING',
  'REVIEW_REQUIRED',
  'REJECTED',
  'PUBLISHED',
  'HIDDEN',
  'RETIRED',
] as const;

export function CellLineCatalogPolicyPage() {
  const { t } = useTranslation();

  const statusRows = statusKeys.map((status) => ({
    key: status,
    status,
    label: t(`admin.catalogPolicy.statuses.${status}.label`),
    meaning: t(`admin.catalogPolicy.statuses.${status}.meaning`),
  }));

  return (
    <>
      <Alert
        type="info"
        showIcon
        message={t('admin.catalogPolicy.summary')}
        style={{ marginBottom: 16 }}
      />

      <Descriptions
        bordered
        size="small"
        column={{ xs: 1, sm: 2, md: 3 }}
        style={{ marginBottom: 16 }}
        items={[
          {
            key: 'scope',
            label: t('admin.catalogPolicy.scopeLabel'),
            children: t('admin.catalogPolicy.scope'),
          },
          {
            key: 'source',
            label: t('admin.catalogPolicy.sourceLabel'),
            children: t('admin.catalogPolicy.source'),
          },
          {
            key: 'boundary',
            label: t('admin.catalogPolicy.boundaryLabel'),
            children: t('admin.catalogPolicy.boundary'),
          },
        ]}
      />

      <Collapse
        defaultActiveKey={['flow', 'rules']}
        items={[
          {
            key: 'flow',
            label: t('admin.catalogPolicy.flowTitle'),
            children: (
              <Typography.Paragraph style={{ marginBottom: 0 }}>
                {t('admin.catalogPolicy.flow')}
              </Typography.Paragraph>
            ),
          },
          {
            key: 'rules',
            label: t('admin.catalogPolicy.rulesTitle'),
            children: (
              <Typography.Paragraph style={{ marginBottom: 0 }}>
                {t('admin.catalogPolicy.rules')}
              </Typography.Paragraph>
            ),
          },
          {
            key: 'ai-boundary',
            label: t('admin.catalogPolicy.aiBoundaryTitle'),
            children: (
              <Typography.Paragraph style={{ marginBottom: 0 }}>
                {t('admin.catalogPolicy.aiBoundary')}
              </Typography.Paragraph>
            ),
          },
          {
            key: 'audit',
            label: t('admin.catalogPolicy.auditTitle'),
            children: (
              <Typography.Paragraph style={{ marginBottom: 0 }}>
                {t('admin.catalogPolicy.audit')}
              </Typography.Paragraph>
            ),
          },
        ]}
        style={{ marginBottom: 16 }}
      />

      <Typography.Title level={5} style={{ marginTop: 0 }}>
        {t('admin.catalogPolicy.statusTitle')}
      </Typography.Title>
      <Table
        size="small"
        pagination={false}
        rowKey="key"
        dataSource={statusRows}
        columns={[
          {
            title: t('admin.catalogPolicy.statusCode'),
            dataIndex: 'status',
            width: 180,
            render: (value: string) => <Tag>{value}</Tag>,
          },
          {
            title: t('admin.catalogPolicy.statusLabel'),
            dataIndex: 'label',
            width: 180,
          },
          {
            title: t('admin.catalogPolicy.statusMeaning'),
            dataIndex: 'meaning',
          },
        ]}
      />
    </>
  );
}
